import React, {useEffect, useState, useRef} from 'react'
import { getMoods } from '../../actions/filterActions'
import { useDispatch, useSelector } from 'react-redux'
import FilterComponent from './FilterComponent';
import AdminFilterComponent from '../../adminContent/AdminVideos/AdminFilterComponent';

const Moods = (props) => {

    const dispatch = useDispatch()
  
    const {error, loading, moods} = useSelector(state => state.moods)

    const [moodList, setMoodList] = useState(moods)

    const [moodActive, setMoodActive] = useState(false)

    const [moodValue, setMoodValue] = useState('')

    const searchMoodRef = useRef()

    useEffect(()=>{
        dispatch(getMoods(props.filterList))
      },[props.filterList, dispatch])


    useEffect(()=>{
        document.addEventListener("mousedown", (event) => {
            if (searchMoodRef == null || searchMoodRef.current == null || !searchMoodRef.current.contains(event.target)){
            setMoodActive(false)
            }
        })
    }) 

        useEffect(()=>{
            setMoodList(moods)
        },[moods])
    
        useEffect(()=>{
            let g = moodList.filter(mood =>
                mood.title.toLowerCase().startsWith(moodValue?.toLowerCase() || ""))
            if(moodValue === ''){
                g = moods
            }
            setMoodList(g)
        },[moodValue])

    const chooseHandler = (mood) => {
        if (props.filterList.filter(g => g[0] === mood.id && g[2] === 2 ).length === 0 ){
            props.setFilterList((prevArr)=>{ return[...prevArr, [mood.id, mood.title, 2]]})
        }
        setMoodActive(false)
        setMoodValue('')
    }


    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            if (moods && moods.length){
                if (props.filterList.filter(g => g[0] === moods[0].id && g[2] === 2 ).length === 0 ){
                    props.setFilterList((prevArr)=>{ return[...prevArr, [moods[0].id, moods[0].title, 2]]})
                }
                setMoodActive(false)
                setMoodValue('')
            }
        }
    }

    return (
        <>
            {
                props.index === 1 ? 
                <AdminFilterComponent
                    data = {moods}
                    setValue = {setMoodValue}
                    setActive = {setMoodActive}
                    value = {moodValue}
                    isActive = {moodActive}
                    chooseHandler = {chooseHandler}
                    componentRef = {searchMoodRef}
                    title = "Moods"
                    loading = {loading}
                /> :
                <FilterComponent
                    data = {moodList}
                    setValue = {setMoodValue}
                    setActive = {setMoodActive}
                    value = {moodValue}
                    isActive = {moodActive}
                    chooseHandler = {chooseHandler}
                    componentRef = {searchMoodRef}
                    title = "Moods"
                    loading = {loading}
                    handleKeyDown = {handleKeyDown}
            />
            }
        </>
    );
};

export default Moods;